var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved",
    transform: "translate(-1468 -235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7839",
    "data-name": "Group 7839",
    transform: "translate(-8804 -7598)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_374",
    "data-name": "Ellipse 374",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(10272 7833)",
    fill: "#1b9cc8",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7843",
    "data-name": "Group 7843",
    transform: "translate(10281 7844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M22.937,15.032a4.1,4.1,0,0,0-2.443-2.808,4.185,4.185,0,0,0-3.42.162,5.313,5.313,0,0,0-6.08-2.808,5.2,5.2,0,0,0-4.071,5.4,4.108,4.108,0,0,0,1.194,8.047h.923a3.466,3.466,0,0,1-.163-1.08h-.76a2.919,2.919,0,0,1-3.04-2.808,2.893,2.893,0,0,1,2.5-3.24l.543-.108-.054-.54a4.056,4.056,0,0,1,3.2-4.7,4.084,4.084,0,0,1,1.14-.108A4.057,4.057,0,0,1,16.369,13.3l.217.7.6-.432a3.016,3.016,0,0,1,2.931-.378,2.931,2.931,0,0,1,1.846,2.322l.054.324.326.108A2.9,2.9,0,0,1,24.565,19.3a2.979,2.979,0,0,1-3.04,2.646H20.82a3.466,3.466,0,0,1-.163,1.08h.923a4.035,4.035,0,0,0,4.071-3.618A3.973,3.973,0,0,0,22.937,15.032Z",
    transform: "translate(-3.983 -9.434)",
    fill: "#1b9cc8",
    stroke: "#1b9cc8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1241",
    "data-name": "Group 1241",
    transform: "translate(5.882 7.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M19.984,23a4.984,4.984,0,1,0,4.984,4.984A4.963,4.963,0,0,0,19.984,23Zm0,8.86a3.876,3.876,0,1,1,3.876-3.876A3.852,3.852,0,0,1,19.984,31.86Z",
    transform: "translate(-15 -23)",
    fill: "#1b9cc8",
    stroke: "#1b9cc8",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M22.769,28H21.661v1.661H20v1.107h1.661V32.43h1.107V30.769H24.43V29.661H22.769Z",
    transform: "translate(-17.231 -25.231)",
    fill: "#1b9cc8",
    stroke: "#1b9cc8",
    strokeWidth: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountNotification);
export default __webpack_public_path__ + "static/media/account-notification.a318388cbfe1470aeaa848576d6b6e5e.svg";
export { ForwardRef as ReactComponent };